import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  border: none;\n  margin: 0;\n  padding: 0;\n  background: none;\n  font-size: 200%;\n  margin-top: -3px;\n  outline: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import { MemoryRouter, Route } from 'react-router-dom';
import styled from 'styled-components';
var LIGHT_GRAY = 'hsl(0, 0%, 32%)';
var GRAY = 'hsl(0, 0%, 78%)';

var LeftArrowIcon = function LeftArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "currentColor",
    viewBox: "0 0 40 40",
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.3 18.3h-12.6l3.8-3.8c0.7-0.6 0.7-1.7 0-2.3s-1.7-0.7-2.3 0l-7.9 7.8 7.9 7.8c0.3 0.4 0.7 0.5 1.1 0.5s0.9-0.1 1.2-0.5c0.7-0.6 0.7-1.7 0-2.3l-3.8-3.8h12.6c1 0 1.7-0.8 1.7-1.7s-0.8-1.7-1.7-1.7z"
  }));
};

var RightArrowIcon = function RightArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "currentColor",
    viewBox: "0 0 40 40",
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.2 12.2c-0.7 0.6-0.7 1.7 0 2.3l3.8 3.8h-12.7c-0.9 0-1.6 0.8-1.6 1.7s0.7 1.7 1.6 1.7h12.7l-3.8 3.8c-0.7 0.6-0.7 1.7 0 2.3 0.3 0.4 0.7 0.5 1.1 0.5s0.9-0.1 1.2-0.5l7.9-7.8-7.9-7.8c-0.6-0.7-1.7-0.7-2.3 0z"
  }));
};

var FileCodeIcon = function FileCodeIcon(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ["style"]);

  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "currentColor",
    height: "1em",
    width: "1em",
    viewBox: "0 0 40 40",
    preserveAspectRatio: "xMidYMid meet",
    style: _objectSpread({
      verticalAlign: 'middle'
    }, style)
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.3 15l-6.3 6.3 6.3 6.2 2.5-2.5-3.8-3.7 3.8-3.8-2.5-2.5z m5 2.5l3.7 3.8-3.7 3.7 2.5 2.5 6.2-6.2-6.2-6.3-2.5 2.5z m6.2-15h-22.5v35h30v-27.5l-7.5-7.5z m5 32.5h-25v-30h17.5l7.5 7.5v22.5z"
  }));
};

var SButton = styled.button(_templateObject());

var getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
};

var createPath = function createPath(location) {
  return location.pathname + location.search;
};

var FakeBrowser = function FakeBrowser(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      url = _useState2[0],
      setUrl = _useState2[1];

  return /*#__PURE__*/React.createElement(MemoryRouter, {
    getUserConfirmation: getUserConfirmation
  }, /*#__PURE__*/React.createElement(Route, {
    render: function render(_ref3) {
      var history = _ref3.history,
          location = _ref3.location;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: "wind-fake-browser",
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'stretch',
          //
          backgroundColor: 'white',
          boxShadow: '0px 5px 20px hsla(0, 0%, 0%, 0.75)',
          borderRadius: '6px',
          height: '100%',
          width: '100%'
        }
      }, props), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          //
          backgroundColor: '#eee',
          borderTopLeftRadius: '6px',
          borderTopRightRadius: '6px',
          border: 'none',
          borderBottom: 'solid 1px #ccc',
          padding: '0 10px'
        },
        className: "wind-fake-browser__address-bar"
      }, /*#__PURE__*/React.createElement(SButton, {
        onClick: history.goBack
      }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
        height: "1em",
        width: "1em",
        style: {
          verticalAlign: 'middle',
          marginTop: -3
        }
      })), /*#__PURE__*/React.createElement(SButton, {
        onClick: history.goForward
      }, /*#__PURE__*/React.createElement(RightArrowIcon, {
        height: "1em",
        width: "1em",
        style: {
          verticalAlign: 'middle',
          marginTop: -3
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          //
          flex: '1 1 auto',
          padding: '5px',
          marginLeft: '-12px'
        }
      }, /*#__PURE__*/React.createElement(FileCodeIcon, {
        style: {
          position: 'relative',
          zIndex: 1,
          left: '20px',
          color: GRAY
        }
      }), /*#__PURE__*/React.createElement("input", {
        style: {
          font: 'inherit',
          width: '100%',
          paddingLeft: '25px',
          color: LIGHT_GRAY
        },
        type: "text",
        value: url || createPath(location),
        onChange: function onChange(e) {
          setUrl(e.target.value);
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            setUrl(null);
            history.push(e.target.value);
          }
        }
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1 1 auto',
          padding: '20px',
          overflow: 'auto',
          position: 'relative'
        },
        className: "wind-fake-browser__content-root"
      }, children));
    }
  }));
};

export default FakeBrowser;